import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { startSignInProcess } from "../services/login";
import {
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row
} from "reactstrap";
import { Spin } from "antd";
import logo from "../../bvmlogo.png";
import { regExp } from "../config";
import { checkAuth } from "../store/loginAction";

class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      loginError: "",
      expZoomIn: false,
      loading: false,
      errors: {}
    };
  }

  onLogin = () => {
    const { email, password } = this.state;
    const errors = {};
    this.setState({ loginError: "" });
    if (!email || email) {
      let emailError = true;
      if (email) {
        emailError = regExp.email.test(email);
        errors.email = !emailError ? "Enter a valid Email" : "";
      } else if (!email) {
        errors.email = "Enter Your Email";
      } else {
        delete errors.email;
      }
    }
    if (!password) {
      errors.password = !password ? "Enter Your password" : "";
    }
    this.setState({
      errors
    });
    if ((errors && errors.email !== "") || (errors && errors.password)) {
      return;
    }
    this.setState(
      {
        loading: true
      },
      async () => {
        const res = await startSignInProcess({ email, password });

        if (res.success) {
          this.setState({ loading: false });
          localStorage.setItem("email", email);
          localStorage.setItem("token", res.token);

          this.props.onLoginSuccess(res.token);
          this.props.history.push("/profile");
        } else {
          this.setState({
            loading: false,
            loginError: res.message
          });
        }
      }
    );
  };

  onChange = e => {
    const { name, value } = e.target;
    let error = true;
    if (name === "email") {
      error = regExp.email.test(value);
    }
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        [name]: !error ? "Enter a valid Email" : ""
      },
      [name]: value
    }));
  };

  render() {
    const { email, password, errors, loginError } = this.state;

    return (
      <div
        className="app flex-row align-items-center"
        style={{ marginTop: 50 }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup>
                <Card className="p-4">
                  <Spin spinning={this.state.loading} size="large" delay={600}>
                    <CardBody>
                      <img
                        style={{ padding: "0 110px" }}
                        className="card-img-top"
                        src={logo}
                        alt="logo"
                      />
                      <hr />
                      <h4>Sign in to your account here</h4>

                      <InputGroup
                        className={errors && errors.email ? "" : "mb-3"}
                      >
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="far fa-envelope" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="email"
                          placeholder="Email"
                          name="email"
                          value={email}
                          onChange={this.onChange}
                        />
                      </InputGroup>
                      {errors && errors.email ? (
                        <small className="text-danger">{errors.email}</small>
                      ) : null}

                      <InputGroup
                        className={errors && errors.password ? "" : "mb-4"}
                      >
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fas fa-key" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="password"
                          placeholder="Password"
                          name="password"
                          value={password}
                          onChange={this.onChange}
                        />
                      </InputGroup>
                      {errors && errors.password ? (
                        <small className="text-danger">{errors.password}</small>
                      ) : null}
                      {loginError ? (
                        <p className="text-danger">{loginError}</p>
                      ) : null}
                      <div className="row justify-content-center">
                        <button
                          className="btn btn-primary"
                          onClick={this.onLogin}
                        >
                          Sign In
                        </button>
                      </div>

                      <br />
                      <FormGroup row className="my-0">
                        <Col xs="12" md="12">
                          <div className="row justify-content-sm-start">
                            <Link to="/signup">Create new account</Link>
                          </div>
                        </Col>
                      </FormGroup>
                    </CardBody>
                  </Spin>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onLoginSuccess: token => dispatch(checkAuth(token))
  };
};
export default connect(null, mapDispatchToProps)(SignIn);
